/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Defines how a form links entries to People form entries.
 */
export enum PeopleLinkingMode {
    /**
     * No people linking - entries are standalone.
     */
	None = 'None',
    /**
     * The referenced Person entry is the linked person.
     */
	PersonField = 'PersonField',
    /**
     * Match by email, or create new Person entry.
     */
	FieldMapping = 'FieldMapping',
}
